import { http } from "./http";

export function getCities(name, groupId) {
    return http.get(`v1/address/municipalities/autocomplete`, {
        params: {
            city: name,
            groupId
        }
    });
}

export function getCityByCode(code) {
    return http.get(`v1/address/municipalities/${code}`);
}